import { Box } from '@mui/material';
import { DiscoverySectionData } from 'services/store/discovery/types';
import SectionsHeader from '../SectionsHeader';
import DiscoverySection from '../DiscoverySection';
import { StyledWrapper } from './style';

type Props = {
  sections: DiscoverySectionData[];
};

const DiscoverySections = ({ sections }: Props) => (
  <>
    <SectionsHeader />
    <StyledWrapper>
      {sections.map((section) => (
        <Box
          key={`${section.kind}-${section.id}`}
          data-testid={`${section.kind}`}
        >
          <DiscoverySection section={section} />
        </Box>
      ))}
    </StyledWrapper>
  </>
);

export default DiscoverySections;
